import { useMemo, useState } from 'react';
import { useContextStore } from './ProstoreContext';
import { useConnectStore } from './useConnectStore';
/**
 * Хук, подключающий компонент к стору
 */
export function useStore(storeOrName) {
    var store = useContextStore(storeOrName);
    var _a = useState(store.state), state = _a[0], setState = _a[1];
    useConnectStore(store, setState);
    return [state, store];
}
/**
 * Хук, подключающий компонент к стору
 */
export function useStoreState(storeOrName) {
    var store = useContextStore(storeOrName);
    var _a = useState(store.state), state = _a[0], setState = _a[1];
    useConnectStore(store, setState);
    return state;
}
/**
 * Хук, подключащий компонент к стору и возвращающий часть состояния
 */
export function useStoreSelect(storeOrName, select) {
    var _a = useStore(storeOrName), state = _a[0], store = _a[1];
    var selectedState = useMemo(function () { return select(state); }, [select, state]);
    return [selectedState, store];
}
//# sourceMappingURL=useStore.js.map